export default __webpack_public_path__ + "static/media/walls-6157947_1920.66fdb143.jpg";